export default __webpack_public_path__ + "static/media/amazon.765fa490.svg";